"use strict";

module.exports = {
  GradientInterpolationTypes: require('./GradientModels').GradientInterpolationType,
  GradientTypes: require('./GradientModels').GradientType,
  GradientStop: require('./GradientModels').GradientStop,
  GradientWorker: require('./GradientExtractor.worker')
};